/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_NoInputs */

const en_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const es_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const ja_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const zh_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`否`)
};

const ar_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا`)
};

const id_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

const it_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const ru_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const pt_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const ko_val_no = /** @type {(inputs: Val_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아니요`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Val_NoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_no = /** @type {((inputs?: Val_NoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_NoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_no(inputs)
	if (locale === "es") return es_val_no(inputs)
	if (locale === "fr") return fr_val_no(inputs)
	if (locale === "de") return de_val_no(inputs)
	if (locale === "ja") return ja_val_no(inputs)
	if (locale === "zh") return zh_val_no(inputs)
	if (locale === "ar") return ar_val_no(inputs)
	if (locale === "id") return id_val_no(inputs)
	if (locale === "it") return it_val_no(inputs)
	if (locale === "ru") return ru_val_no(inputs)
	if (locale === "pt") return pt_val_no(inputs)
	return ko_val_no(inputs)
});